import React from "react";
import { connect } from "react-redux";
import { dismissMessage, hideMessage } from "../../redux/actions/billboard";
import { billboardMessageLifetime } from "../../constants";

const mapDispatchToProps = dispatch => ({
    dismiss: messageId => dispatch(dismissMessage(messageId)),
    hide: messageId => dispatch(hideMessage(messageId))
});

const messageTypes = {
    info: "info",
    information: "info",
    error: "error",
    warn: "warn",
    warning: "warn",
    success: "success"
};

/**
 * Expecting a message in the following format:
 *  {
 *      message: "The content of the message, as a string",
 *      id: string, pre-populated by the reducer. don't worry about it.
 *      lifetime: default `billboardMessageLifetime`, how long, in milliseconds, this message stays visible
 *      sticky: boolean, default false, whether to leave the message on the screen indefinitely (until user closes manually)
 *  }
 */

class Message extends React.Component {

    constructor(){
        super();
        this.state = {
            dismissTimeout: null
        };
    }

    componentDidMount(){
        const {hidden, id, sticky, hide, lifetime} = this.props;
        if(sticky !== true && hidden !== true){
            setTimeout(() => {
                hide(id);
            }, lifetime ? lifetime : billboardMessageLifetime);
        }
    }

    componentDidUpdate(){
        const {hidden, dismiss, id} = this.props;
        if(hidden && !this.state.dismissTimeout){

            this.setState({
                ...this.state,
                dismissTimeout: setTimeout((messageId) => {
                    dismiss(messageId);
                }, 500, id)
            });
        }
    }

    componentWillUnmount(){
        if(this.state.dismissTimeout){
            clearTimeout(this.state.dismissTimeout);
        }
    }

    render() {
        const { message, id, type, hide, hidden } = this.props;
        const messageType = messageTypes.hasOwnProperty(type) ? messageTypes[type] : messageTypes.info;
        return (
            <div className={`billboard-message-wrapper ${hidden ? " hidden" : ""}`}>
                <div className={`billboard-message${messageType ? ` msg-${messageType}` : ""}`}>
                    <div className="message-icon">
                        <img src={`/static/billboard/msg-${messageType}.svg`} alt={`${messageType} icon`}/>
                    </div>
                    <div className="message-content">{message}</div>
                    <div className="message-control">
                        <button onClick={() => hide(id)} title="Dismiss this message.">X</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(undefined, mapDispatchToProps)(Message);